// EIGOO Partners Portal — bilingual dictionary (EN / VI)
// cache-bust: 2026-09-01T11:07Z fresh deploy after i18n parse fix
export const STRINGS = {
  en: {
    brand: "EIGOO Inc.",
    brand_sub: "Partners Portal",
    domain_tag: "partners.eigooinc.net",
    login_title: "Sign in to the Fleet",
    login_sub: "One portal for the full partner pipeline — Scout, Affiliate, Operator.",
    email: "Email",
    password: "Password",
    sign_in: "Sign in",
    signing_in: "Signing in…",
    invalid_creds: "Invalid credentials. Please try again.",
    demo_hint: "Try linro@eigooinc.net (scout) or operator@eigooinc.net (operator)",
    logout: "Log out",
    lang_toggle_label: "Language",
    welcome: "Welcome back",
    role_scout: "Scout",
    role_operator: "Operator",
    role_affiliate: "Affiliate",
    referral_code: "Referral code",
    referral_link: "Referral link",
    copy: "Copy",
    copied: "Copied to clipboard",

    /* Scout */
    stats_submitted: "Referrals Submitted",
    stats_signed: "Signed / Converted",
    stats_earnings: "Total Earnings",
    stats_signed_sub: "signed prospects",
    stats_earnings_sub: "$50 per signed referral",
    earnings_by_hull: "Earnings by Fleet Asset",
    earnings_by_hull_sub: "Commission tracked across every EIGOO hull",
    hull_col: "Fleet Asset",
    hull_submitted: "Submitted",
    hull_signed: "Signed",
    hull_earnings: "Earnings",
    no_earnings_yet: "No earnings yet — submit your first referral to start.",
    new_referral_title: "Log a new referral",
    new_referral_sub: "Attach any EIGOO service — commission tracked across the full fleet.",
    prospect_name: "Prospect name",
    business_name: "Business name",
    phone: "Phone",
    prospect_email: "Prospect email",
    hull_service: "Fleet asset / service",
    hull_service_ph: "Select an EIGOO service",
    notes: "Notes",
    notes_ph: "Anything the closer should know…",
    submit_referral: "Submit referral",
    submitting: "Submitting…",
    referral_created: "Referral submitted",
    referral_error: "Could not submit referral",
    required: "Required",
    my_referrals: "My Referrals",
    my_referrals_sub: "Status updates flow from the Fleet Operator",
    export_csv: "Export CSV",
    col_created: "Date",
    col_prospect: "Prospect",
    col_business: "Business",
    col_hull: "Asset",
    col_status: "Status",
    col_commission: "Commission",
    col_scout: "Scout",
    empty_referrals: "No referrals logged yet.",
    empty_referrals_sub: "Tap “New Referral” above to log your first prospect.",
    status_submitted: "Submitted",
    status_contacted: "Contacted",
    status_signed: "Signed",
    status_declined: "Declined",
    per_signed: "per signed referral",
    approx: "approx.",

    /* Operator */
    op_hero_title: "Fleet Delivery Command",
    op_hero_sub: "Route every partner referral through the pipeline. You control statuses, revenue share, and hand-off.",
    op_queue: "Delivery Queue",
    op_queue_sub: "All referrals, every scout, every fleet asset",
    op_summary_gross: "Gross Setup Fees",
    op_summary_scout_payouts: "Scout Payouts",
    op_summary_op_share: "Operator Revenue Share",
    op_summary_net_fleet: "Net Fleet Retained",
    op_setup_fee_hint: "$500 per signed client",
    op_share_hint: "$180 per signed client",
    op_net_hint: "after scout + operator share",
    op_filter_status: "Filter by status",
    op_filter_hull: "Filter by asset",
    op_filter_all: "All",
    op_update_status: "Update status",
    op_saved: "Status updated",
    op_save_err: "Could not update status",
    by_scout: "By Scout",
    by_hull: "By Fleet Asset",
    total_signed: "Signed",
    total_pending: "Pending",
    total_declined: "Declined",
    total_referrals: "Referrals",

    /* Earning streams */
    streams_title: "All Earning Streams",
    streams_sub: "Referrals · Amazon Sub-Affiliate · Digital Marketplaces — one combined view.",
    combined_total: "Combined Total",
    stream_referral: "EIGOO Referrals",
    stream_referral_sub: "$50 per signed EIGOO client",
    stream_amazon: "Amazon Sub-Affiliate",
    stream_amazon_sub: "Cut of purchases through EIGOO's Amazon links",
    stream_marketplace: "Digital / Marketplace",
    stream_marketplace_sub: "Siren Storefront, courses, templates & 3rd-party stores",
    entries: "entries",
    streams_future_hint: "Extensible: Gumroad, Etsy, Shopify, Payhip, Teachable and more can be logged as new marketplace sources.",
    payouts_table: "Amazon & Marketplace Payouts",
    payouts_table_sub: "Every logged sale across the digital fleet",
    empty_payouts: "No Amazon or marketplace payouts logged yet.",
    empty_payouts_sub: "The Operator will add entries here as marketplace sales settle.",
    col_stream: "Stream",
    col_source: "Source",
    col_amount: "Amount",
    col_ref: "Ref",
    col_desc: "Notes",

    /* Operator log-earnings form */
    op_log_earnings: "Log a Payout",
    op_log_earnings_sub: "Record an Amazon or marketplace sale for a partner. Referral commissions are auto-tracked from the queue.",
    op_pick_scout: "Partner",
    op_pick_scout_ph: "Select a partner",
    op_pick_stream: "Stream",
    op_pick_source: "Source",
    op_pick_source_ph: "e.g. Amazon Associates, Siren Storefront",
    op_amount_usd: "Amount (USD)",
    op_occurred_at: "Occurred at",
    op_external_ref: "External reference",
    op_external_ref_ph: "Order ID, transaction ID…",
    op_desc: "Description",
    op_desc_ph: "Optional detail…",
    op_log_submit: "Log payout",
    op_log_ok: "Payout logged",
    op_log_err: "Could not log payout",
    op_partner_payouts_all: "Total Partner Payouts",
    op_partner_payouts_all_sub: "referrals + amazon + marketplace",
    op_amazon_card: "Amazon Payouts",
    op_amazon_card_sub: "sub-affiliate cuts",
    op_market_card: "Marketplace Payouts",
    op_market_card_sub: "digital + storefront sales",

    /* Tier & downline */
    current_tier: "Current Tier",
    active_rate: "active",
    passive_rate: "passive",
    tier_disclaimer: "Max 1 level deep — passive rate always below active. Cookie window: 180 days for EIGOO referrals; external programs follow their own.",
    passive_from_downline: "Passive from Sub-Affiliates",
    downline_count: "Sub-affiliates",
    downline_signed: "Signed",
    next_tier: "Next Tier",
    youre_missing: "You're missing",
    ask_upgrade: "Ask Operator to promote you",
    top_tier_reached: "You're at the top of the ladder.",
    tier_scout: "Scout",
    tier_refer_close: "Refer + Close",
    tier_operator: "Operator",
    downline_title: "My Sub-Affiliates",
    downline_sub: "Passive override earnings from your direct downline",
    downline_total_passive: "Total Passive Earnings",
    downline_hint: "Passive commissions post automatically when a sub-affiliate's referral is marked signed.",
    no_downline: "No sub-affiliates yet.",
    no_downline_sub: "Ask the Operator to invite scouts under your code. You'll earn a passive override on every deal they close.",
    col_tier: "Tier",
    col_signed: "Signed",
    col_passive_earnings: "Passive Earnings",

    /* Invite scout (operator) */
    invite_title: "Invite a Scout",
    invite_sub: "Create a partner and optionally attach them under an existing scout as a sub-affiliate (1 level deep max).",
    invite_name: "Full name",
    invite_code: "Referral code",
    invite_tier: "Tier",
    invite_parent: "Parent scout (optional)",
    invite_no_parent: "— No parent (top-level) —",
    invite_active_override: "Active override",
    invite_passive_override: "Passive override",
    invite_submit: "Invite scout",
    invite_ok: "Scout invited",
    invite_err: "Could not invite scout",

    /* Close type on new referral form */
    close_type_label: "Close style",
    close_refer_only: "Refer only (needs closer)",
    close_refer_close: "Refer + Close (self-serve funnel)",
    close_hint: "Self-serve or Refer+Close pays full active rate. Refer-only splits 10% to the closer.",

    /* 30-day hold */
    hold_pending: "Pending (in hold)",
    hold_day_window: "day refund window",
    hold_released: "Released (cleared)",
    hold_released_sub: "available for payout",
    hold_cancelled: "Cancelled",
    hold_cancelled_sub: "refunded / voided",
    hold_disclaimer: "Signed commissions hold for 30 days, then auto-release. Cancellations inside the hold window zero the earning.",

    /* Link builder */
    link_builder_title: "Custom Short Links",
    link_builder_sub: "Build partners.eigooinc.net/l/CODE/slug links to any destination. Every click is credited to your code.",
    link_slug: "Slug",
    link_destination: "Destination URL",
    link_label: "Label",
    link_label_ph: "Amazon starter kit, TechOps landing…",
    link_stream: "Stream tag",
    link_stream_any: "Any",
    link_source: "Source",
    link_create: "Create",
    link_created: "Link created",
    link_updated: "Link updated",
    link_deleted: "Link deleted",
    link_error: "Could not save link",
    link_confirm_delete: "Delete this link and its click history?",
    link_manager_title: "Your Links",
    link_manager_hint: "clicks tracked in real time",
    no_links_yet: "No custom links yet — build your first one above.",
    clicks: "clicks",

    footer: "EIGOO Inc. — Partners Portal",
  },
  vi: {
    brand: "EIGOO Inc.",
    brand_sub: "Cổng Đối Tác",
    domain_tag: "partners.eigooinc.net",
    login_title: "Đăng nhập vào Hạm Đội",
    login_sub: "Một cổng cho toàn bộ chuỗi đối tác — Scout, Affiliate, Operator.",
    email: "Email",
    password: "Mật khẩu",
    sign_in: "Đăng nhập",
    signing_in: "Đang đăng nhập…",
    invalid_creds: "Thông tin đăng nhập không đúng. Vui lòng thử lại.",
    demo_hint: "Thử linro@eigooinc.net (scout) hoặc operator@eigooinc.net (operator)",
    logout: "Đăng xuất",
    lang_toggle_label: "Ngôn ngữ",
    welcome: "Chào mừng trở lại",
    role_scout: "Cộng Tác Viên",
    role_operator: "Vận Hành Hạm Đội",
    role_affiliate: "Đại Lý",
    referral_code: "Mã giới thiệu",
    referral_link: "Liên kết giới thiệu",
    copy: "Sao chép",
    copied: "Đã sao chép",

    stats_submitted: "Đã Gửi Giới Thiệu",
    stats_signed: "Đã Ký / Chuyển Đổi",
    stats_earnings: "Tổng Hoa Hồng",
    stats_signed_sub: "khách hàng đã ký",
    stats_earnings_sub: "50 USD mỗi khách đã ký",
    earnings_by_hull: "Hoa Hồng Theo Mảng Dịch Vụ",
    earnings_by_hull_sub: "Theo dõi hoa hồng trên toàn bộ hạm đội EIGOO",
    hull_col: "Dịch vụ",
    hull_submitted: "Đã gửi",
    hull_signed: "Đã ký",
    hull_earnings: "Hoa hồng",
    no_earnings_yet: "Chưa có hoa hồng — gửi giới thiệu đầu tiên để bắt đầu.",
    new_referral_title: "Ghi nhận giới thiệu mới",
    new_referral_sub: "Chọn bất kỳ dịch vụ EIGOO — hoa hồng theo dõi trên toàn hạm đội.",
    prospect_name: "Tên khách hàng",
    business_name: "Tên doanh nghiệp",
    phone: "Số điện thoại",
    prospect_email: "Email khách hàng",
    hull_service: "Dịch vụ / mảng EIGOO",
    hull_service_ph: "Chọn một dịch vụ EIGOO",
    notes: "Ghi chú",
    notes_ph: "Thông tin bổ sung cho đội chốt hợp đồng…",
    submit_referral: "Gửi giới thiệu",
    submitting: "Đang gửi…",
    referral_created: "Đã gửi giới thiệu",
    referral_error: "Không thể gửi giới thiệu",
    required: "Bắt buộc",
    my_referrals: "Giới Thiệu Của Tôi",
    my_referrals_sub: "Trạng thái cập nhật từ Operator hạm đội",
    export_csv: "Xuất CSV",
    col_created: "Ngày",
    col_prospect: "Khách hàng",
    col_business: "Doanh nghiệp",
    col_hull: "Dịch vụ",
    col_status: "Trạng thái",
    col_commission: "Hoa hồng",
    col_scout: "Cộng tác viên",
    empty_referrals: "Chưa có giới thiệu nào.",
    empty_referrals_sub: "Nhấn “Giới Thiệu Mới” ở trên để ghi nhận khách hàng đầu tiên.",
    status_submitted: "Đã gửi",
    status_contacted: "Đã liên hệ",
    status_signed: "Đã ký",
    status_declined: "Từ chối",
    per_signed: "cho mỗi khách đã ký",
    approx: "khoảng",

    op_hero_title: "Trung Tâm Điều Phối Hạm Đội",
    op_hero_sub: "Định tuyến toàn bộ giới thiệu qua pipeline. Bạn kiểm soát trạng thái, chia doanh thu, bàn giao.",
    op_queue: "Hàng Chờ Giao Việc",
    op_queue_sub: "Tất cả giới thiệu, mọi scout, mọi mảng dịch vụ",
    op_summary_gross: "Tổng Phí Kích Hoạt",
    op_summary_scout_payouts: "Chi Trả Cho Scout",
    op_summary_op_share: "Chia Doanh Thu Operator",
    op_summary_net_fleet: "Doanh Thu Hạm Đội Ròng",
    op_setup_fee_hint: "500 USD mỗi khách đã ký",
    op_share_hint: "180 USD mỗi khách đã ký",
    op_net_hint: "sau chia cho scout + operator",
    op_filter_status: "Lọc theo trạng thái",
    op_filter_hull: "Lọc theo mảng",
    op_filter_all: "Tất cả",
    op_update_status: "Cập nhật trạng thái",
    op_saved: "Đã cập nhật trạng thái",
    op_save_err: "Không thể cập nhật trạng thái",
    by_scout: "Theo Scout",
    by_hull: "Theo Mảng Dịch Vụ",
    total_signed: "Đã ký",
    total_pending: "Chờ xử lý",
    total_declined: "Từ chối",
    total_referrals: "Giới thiệu",

    /* Earning streams (VI) */
    streams_title: "Toàn Bộ Nguồn Thu Nhập",
    streams_sub: "Giới thiệu · Amazon Sub-Affiliate · Chợ số — một bảng tổng hợp.",
    combined_total: "Tổng Cộng",
    stream_referral: "Giới Thiệu EIGOO",
    stream_referral_sub: "50 USD mỗi khách EIGOO đã ký",
    stream_amazon: "Amazon Sub-Affiliate",
    stream_amazon_sub: "Chia hoa hồng từ liên kết Amazon của EIGOO",
    stream_marketplace: "Chợ Số / Cửa Hàng",
    stream_marketplace_sub: "Siren Storefront, khoá học, template & cửa hàng bên thứ ba",
    entries: "mục",
    streams_future_hint: "Có thể mở rộng: Gumroad, Etsy, Shopify, Payhip, Teachable — thêm dưới dạng nguồn (source).",
    payouts_table: "Hoa Hồng Amazon & Chợ Số",
    payouts_table_sub: "Mọi khoản đã ghi nhận trên toàn bộ mảng số",
    empty_payouts: "Chưa có khoản Amazon hoặc chợ số nào được ghi nhận.",
    empty_payouts_sub: "Operator sẽ thêm mục ở đây khi giao dịch marketplace thanh toán.",
    col_stream: "Nguồn Thu",
    col_source: "Nguồn",
    col_amount: "Số Tiền",
    col_ref: "Mã",
    col_desc: "Ghi chú",

    op_log_earnings: "Ghi Nhận Khoản Chi",
    op_log_earnings_sub: "Ghi nhận doanh thu Amazon hoặc marketplace cho đối tác. Hoa hồng giới thiệu tự động tính từ hàng chờ.",
    op_pick_scout: "Đối tác",
    op_pick_scout_ph: "Chọn đối tác",
    op_pick_stream: "Nguồn thu",
    op_pick_source: "Nguồn",
    op_pick_source_ph: "vd. Amazon Associates, Siren Storefront",
    op_amount_usd: "Số tiền (USD)",
    op_occurred_at: "Thời gian",
    op_external_ref: "Mã tham chiếu",
    op_external_ref_ph: "Mã đơn, mã giao dịch…",
    op_desc: "Mô tả",
    op_desc_ph: "Chi tiết tuỳ chọn…",
    op_log_submit: "Ghi nhận",
    op_log_ok: "Đã ghi nhận",
    op_log_err: "Không thể ghi nhận",
    op_partner_payouts_all: "Tổng Chi Trả Đối Tác",
    op_partner_payouts_all_sub: "giới thiệu + amazon + marketplace",
    op_amazon_card: "Hoa Hồng Amazon",
    op_amazon_card_sub: "chia sub-affiliate",
    op_market_card: "Hoa Hồng Chợ Số",
    op_market_card_sub: "doanh thu số + cửa hàng",

    /* Link builder (VI) */
    link_builder_title: "Liên Kết Rút Gọn Cá Nhân",
    link_builder_sub: "Tạo liên kết partners.eigooinc.net/l/CODE/slug đến bất kỳ đích nào. Mọi lượt click đều tính cho bạn.",
    link_slug: "Slug",
    link_destination: "URL đích",
    link_label: "Nhãn",
    link_label_ph: "Bộ khởi động Amazon, Landing TechOps…",
    link_stream: "Nguồn",
    link_stream_any: "Bất kỳ",
    link_source: "Nguồn",
    link_create: "Tạo",
    link_created: "Đã tạo liên kết",
    link_updated: "Đã cập nhật",
    link_deleted: "Đã xoá",
    link_error: "Không thể lưu liên kết",
    link_confirm_delete: "Xoá liên kết này và lịch sử click?",
    link_manager_title: "Liên Kết Của Bạn",
    link_manager_hint: "click được theo dõi thời gian thực",
    no_links_yet: "Chưa có liên kết nào — tạo liên kết đầu tiên ở trên.",
    clicks: "click",

    /* Tier & downline (VI) */
    current_tier: "Cấp Bậc Hiện Tại",
    active_rate: "chủ động",
    passive_rate: "thụ động",
    tier_disclaimer: "Tối đa 1 cấp — hoa hồng thụ động luôn thấp hơn chủ động. Cookie: 180 ngày cho EIGOO; nền tảng bên ngoài theo cookie riêng.",
    passive_from_downline: "Thụ Động Từ Downline",
    downline_count: "Cấp dưới",
    downline_signed: "Đã ký",
    next_tier: "Cấp Bậc Tiếp Theo",
    youre_missing: "Bạn đang bỏ lỡ",
    ask_upgrade: "Yêu cầu Operator nâng cấp",
    top_tier_reached: "Bạn đã ở cấp cao nhất.",
    tier_scout: "Scout",
    tier_refer_close: "Refer + Close",
    tier_operator: "Operator",
    downline_title: "Cấp Dưới Của Tôi",
    downline_sub: "Hoa hồng thụ động từ tuyến trực tiếp",
    downline_total_passive: "Tổng Hoa Hồng Thụ Động",
    downline_hint: "Hoa hồng thụ động được ghi nhận tự động khi khách của cấp dưới được đánh dấu đã ký.",
    no_downline: "Chưa có cấp dưới.",
    no_downline_sub: "Yêu cầu Operator mời scout dưới mã của bạn — bạn nhận hoa hồng thụ động cho mọi hợp đồng họ chốt.",
    col_tier: "Cấp",
    col_signed: "Đã ký",
    col_passive_earnings: "Hoa Hồng Thụ Động",

    invite_title: "Mời Scout",
    invite_sub: "Tạo đối tác và tuỳ chọn gắn dưới scout hiện có (tối đa 1 cấp).",
    invite_name: "Họ và tên",
    invite_code: "Mã giới thiệu",
    invite_tier: "Cấp bậc",
    invite_parent: "Scout cha (tuỳ chọn)",
    invite_no_parent: "— Không có (cấp cao nhất) —",
    invite_active_override: "Điều chỉnh chủ động",
    invite_passive_override: "Điều chỉnh thụ động",
    invite_submit: "Mời scout",
    invite_ok: "Đã mời",
    invite_err: "Không thể mời scout",

    close_type_label: "Kiểu chốt",
    close_refer_only: "Chỉ giới thiệu (cần người chốt)",
    close_refer_close: "Giới thiệu + Chốt (funnel tự phục vụ)",
    close_hint: "Tự phục vụ hoặc Refer+Close nhận full hoa hồng. Refer-only chia 10% cho người chốt.",

    /* 30-day hold (VI) */
    hold_pending: "Đang Giữ (trong 30 ngày)",
    hold_day_window: "cửa sổ hoàn tiền",
    hold_released: "Đã Giải Ngân",
    hold_released_sub: "sẵn sàng chi trả",
    hold_cancelled: "Đã Huỷ",
    hold_cancelled_sub: "đã hoàn / vô hiệu",
    hold_disclaimer: "Hoa hồng đã ký được giữ 30 ngày, sau đó tự động giải ngân. Huỷ trong thời gian giữ sẽ về 0.",

    footer: "EIGOO Inc. — Cổng Đối Tác",
  },
};

export const HULL_LABELS = {
  en: {
    techops: "EIGOO TechOps",
    real_estate: "EIGOO Real Estate",
    logistics: "EIGOO Logistics",
    cyberkids: "EIGOO CyberKids",
    armada_sso: "EIGOO Armada SSO",
    command: "EIGOO Command",
    siren_storefront: "EIGOO Siren Storefront",
    other: "Other EIGOO Service",
  },
  vi: {
    techops: "EIGOO TechOps",
    real_estate: "EIGOO Bất Động Sản",
    logistics: "EIGOO Logistics",
    cyberkids: "EIGOO CyberKids",
    armada_sso: "EIGOO Armada SSO",
    command: "EIGOO Command",
    siren_storefront: "EIGOO Siren Storefront",
    other: "Dịch Vụ EIGOO Khác",
  },
};

export const STATUS_LABEL = (lang, s) =>
  ({
    submitted: STRINGS[lang].status_submitted,
    contacted: STRINGS[lang].status_contacted,
    signed: STRINGS[lang].status_signed,
    declined: STRINGS[lang].status_declined,
  }[s] || s);

export const ROLE_LABEL = (lang, r) =>
  ({
    scout: STRINGS[lang].role_scout,
    operator: STRINGS[lang].role_operator,
    affiliate: STRINGS[lang].role_affiliate,
  }[r] || r);

export const t = (lang, key) => (STRINGS[lang] && STRINGS[lang][key]) || key;
